import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlankPagePortrait: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBlankPagePortrait"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H20V15.9643C20 16.8896 19.6988 17.7898 19.1421 18.5295C17.4977 20.7148 14.9176 22 12.1786 22H4ZM18.5 15.5972C18.5 16.0451 18.3509 16.3271 18.1446 16.5235C17.9204 16.737 17.5737 16.8989 17.122 16.9784C16.1935 17.1417 15.104 16.9096 14.5088 16.5142L13.9984 16.1751L12.4598 17.7085C10.6667 19.4956 8.23412 20.5 5.69717 20.5H5.5V3.5H18.5V15.5972Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlankPagePortrait;
